import React, { useState, useEffect } from 'react';
import './App.css';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { TechStack } from './components/TechStack';
import { About } from './components/About';
import { Timeline } from './components/Timeline';
import { Certifications } from './components/Certifications';
import { Hobbies } from './components/Hobbies';
import { Testimonials } from './components/Testimonials';
// import { Blog } from './components/Blog';
import { Contact } from './components/Contact';
import { CodeBackground } from './components/CodeBackground';
import { FaGithub, FaLinkedin, FaEnvelope, FaArrowUp } from 'react-icons/fa';

function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      className="scroll-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
    >
      <FaArrowUp size={16} />
    </button>
  );
}

const Portfolio = () => {
  return (
    <>
      <CodeBackground />
      <Navigation />

      <main>
        <Hero />
        <About />
        <Hobbies />
        <Certifications />
        <TechStack />
        <Timeline />
        {/* <Blog /> */}
        <Testimonials />
        <Contact />
      </main>

      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-socials">
            <a href="https://github.com/Sathish-Kalaimani" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub size={18} />
            </a>
            <a href="https://www.linkedin.com/in/sathish-kalaimani-83927557/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin size={18} />
            </a>
            <a href="mailto:contact@sathishkalaimani.com" aria-label="Email">
              <FaEnvelope size={18} />
            </a>
          </div>
          <div className="footer-nav">
            <a href="#about">About</a>
            <a href="#experience">Experience</a>
            <a href="#contact">Contact</a>
          </div>
          <p className="footer-copy">© 2026 Sathish Kalaimani</p>
        </div>
      </footer>

      <ScrollToTop />
    </>
  );
}

export default Portfolio;